export enum TERMS {
  seconds = 'seconds',
  minutes = 'minutes',
  hours = 'hours',
  days = 'days',
  months = 'months',
  years = 'years',

  symbols = 'symbols',
}
